// extracted by mini-css-extract-plugin
export var activityContainer = "_lh-0";
export var typingIndicatorContainer = "_lh-1";
export var typingIndicatorDot = "_lh-2";
export var wave = "_lh-3";